import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useStore, useDispatch } from 'react-redux'
import { MdOutlineReply } from "react-icons/md";
import { MdOutlineReplyAll } from "react-icons/md";
import { TiArrowForward } from "react-icons/ti";

import ChildEmailHistory from './childEmail';
import { formatDate } from '../../services/helper';
import ModalComponent from '../CommonComponents/Modal';
import ComposeEmail from '../ComposeEmail';
import { AppContext } from '../../context';
import { modifyEmailAsRead, modifyEmailAsReadForMicrosoft } from '../../redux/actions/emailSettings';
import { Loader } from 'rsuite';

const EmailHistory = ({ parentEmail, contacts, handleReplyEmailClose, callerAssignedForEmail, setAllUnreadEmailCount, callers, componentFor, vendorId }) => {
    const {
        setOldEmailDataInContext,
        childEmailHistories,
        setOldEmails,
        oldEmails,
        actionOnEmail,
        setActionOnEmail,
        setParentThread,
        parentEmailHistories,
        setParentEmailHistories,
        getRegisteredEmailsHandler,
        setForwardConversation,
        setValidUnReadEmails,
        validUnReadEmails,
        setEmailConversation,
        getNewUnreadNotification
    } = useContext(AppContext);

    const store = useStore().getState()
    const { auth: { user } } = store
    const dispatch = useDispatch()

    const [mainEmail, setMainEmail] = useState({})
    const [expandEmailHistory, setExpandEmailHistory] = useState({ parentId: null, expand: false })
    const [childEmailsForParentEmail, setChildEmailsForParentEmail] = useState([])
    const [show, setShow] = useState(false)
    const [isModifyingLoader, setIsModifyingLoader] = useState(false)
    const [newChildEmailsExist, setNewChildEmailsExist] = useState(false)

    const onReplyButtonClick = (e, parentEmail, action) => {
        e.stopPropagation();
        setShow(true)
        setActionOnEmail(action)
        setOldEmailDataInContext(parentEmail)
        setOldEmails(parentEmail)
        setParentThread(parentEmail?.domain === 'google' ? parentEmail?.threadId : parentEmail?.messageId)
        if (action === 'forward') {
            setForwardConversation([parentEmail])
        } else if (action === 'reply' ||  action === 'replyAll') {
            setEmailConversation([parentEmail])
        }
    }

    const modifyEmailToRead = async (parentEmail) => {
        setIsModifyingLoader(true)
        let registeredEmailDetails

        if (componentFor === 'masterSupplierDetails' || componentFor === 'relatedSupplierDetails') {
            registeredEmailDetails = await getRegisteredEmailsHandler([callerAssignedForEmail, ...callers])
        } else  {
            registeredEmailDetails = await getRegisteredEmailsHandler([callerAssignedForEmail])
        }

        let registeredEmailDetail = registeredEmailDetails?.filter((registeredEmail) => registeredEmail?.email?.toLowerCase() === parentEmail?.receiverEmail?.toLowerCase())
        if (parentEmail?.domain === 'google') {
            await dispatch(modifyEmailAsRead({ messageId: parentEmail?.messageId, accessToken: registeredEmailDetail[0]?.accessToken, refreshToken: registeredEmailDetail[0]?.refreshToken, email: registeredEmailDetail[0]?.email }))
                .then(() => {
                    setIsModifyingLoader(false)
                    setAllUnreadEmailCount(prevState => prevState - 1)
                    setParentEmailHistories(prevEmails => {
                        return prevEmails?.map((prevEmail) => {
                            if (prevEmail?.messageId === parentEmail?.messageId) {
                                prevEmail.isRead = true
                            }
                            return prevEmail
                        })
                    })
                })
                .catch((err) => {
                    setIsModifyingLoader(false)
                })
        } else {
            await dispatch(modifyEmailAsReadForMicrosoft({ messageId: parentEmail?.messageId, accessToken: registeredEmailDetail[0]?.accessToken, email: registeredEmailDetail[0]?.email }))
                .then(() => {
                    setIsModifyingLoader(false)
                    setAllUnreadEmailCount(prevState => prevState - 1)
                    setParentEmailHistories(prevEmails => {
                        return prevEmails?.map((prevEmail) => {
                            if (prevEmail?.messageId === parentEmail?.messageId) {
                                prevEmail.isRead = true
                            }
                            return prevEmail
                        })
                    })
                })
                .catch((err) => {
                    setIsModifyingLoader(false)
                })
        }
        getNewUnreadNotification()
    }

    const updateParentEmailForNewTag = (domain, id, cb) => {
        let tmpChildEmailsForParent = []
        let tmpNewChildEmailExist

        if (domain === 'microsoft') {
            tmpChildEmailsForParent = childEmailHistories?.filter((childEmail) => childEmail?.conversationId === id)?.sort((a, b) => new Date(b?.sentDate) - new Date(a?.sentDate))
        } else {
            tmpChildEmailsForParent = childEmailHistories?.filter((childEmail) => childEmail?.threadId === id)?.sort((a, b) => new Date(b?.sentDate) - new Date(a?.sentDate))
        }

        tmpNewChildEmailExist = tmpChildEmailsForParent?.find(childEmail => !childEmail?.isRead);
        if (tmpNewChildEmailExist?.messageId) {
            setNewChildEmailsExist(true)
        } else {
            setNewChildEmailsExist(false)
        }

    
        if (!cb && expandEmailHistory?.expand && expandEmailHistory?.parentId === id) {
            setChildEmailsForParentEmail(tmpChildEmailsForParent)
        } else if (!cb) {
            return
        } else {
            cb(tmpChildEmailsForParent)
        }

    }

     const onExpandHandler = async (domain, id, parentEmail) => {
        updateParentEmailForNewTag(domain, id, async (tmpChildEmailsForParent) => {
            if (!parentEmail?.isRead) {
                if (tmpChildEmailsForParent?.length === 0) {
                    await modifyEmailToRead(parentEmail)
                }
            }
            setChildEmailsForParentEmail(tmpChildEmailsForParent)
            setExpandEmailHistory({ parentId: expandEmailHistory?.expand ? null : id, expand: !expandEmailHistory?.expand })
        })
    }

    useEffect(() => {
        updateParentEmailForNewTag(parentEmail?.domain, parentEmail?.domain === 'microsoft' ? parentEmail?.conversationId : parentEmail?.threadId, null)
    }, [parentEmailHistories, childEmailHistories])

    return (
        <>
            <div
                className='border flex-column rounded p-3 mb-3  position-relative'
                style={{ height: 'auto', cursor: 'pointer' }}
                key={parentEmail?.domain === 'microsoft' ? parentEmail?.parentId : parentEmail?.threadId}
                onClick={() => { onExpandHandler(parentEmail?.domain, parentEmail?.domain === 'microsoft' ? parentEmail?.conversationId : parentEmail?.threadId, parentEmail) }}
            >
                <div className='d-flex justify-content-between'>
                    <div className='d-flex justify-content-between'>
                        <h3 className='fw-bold' style={{ color: '#214466' }}>{parentEmail?.subject?.toUpperCase()}</h3>
                    </div>
                    {
                        !parentEmail?.hideActionBtn && <div className='d-flex align-items-center gap-2'>
                            <button className='email_action_button' title='Reply' onClick={(e) => { onReplyButtonClick(e, parentEmail, 'reply') }} ><MdOutlineReply size={18} /></button>
                            <button className='email_action_button' title='Reply All' onClick={(e) => { onReplyButtonClick(e, parentEmail, 'replyAll') }}><MdOutlineReplyAll size={18} /></button>
                            <button className='email_action_button' title='Forward' onClick={(e) => { onReplyButtonClick(e, parentEmail, 'forward') }}><TiArrowForward size={18} /></button>
                        </div>
                    }
                </div>
                <div className={`d-flex ${!expandEmailHistory?.expand && 'column-gap-4'}`}>
                    <p className='fw-bold fs-5' style={{ color: '#214466', letterSpacing: 1 }}>{formatDate(parentEmail?.receivedDate)} ( {parentEmail?.timeSpan} )</p>
                    {
                        !expandEmailHistory?.expand && (<p className='fw-bold m-0 fs-5' style={{ color: '#214466', letterSpacing: 1 }}>{parentEmail?.senderEmail} {' -> '} {parentEmail?.receiverEmail}</p>)
                    }
                </div>
                {
                    !expandEmailHistory?.expand && (
                        parentEmail?.body && parentEmail.body.length > 100
                            ? <p>{`${parentEmail?.body?.substring(0, 100)}...`}</p>
                            : <p className='fs-4'>{parentEmail?.body}</p>
                    )
                }
                {isModifyingLoader ? <div className='d-flex justify-content-center'><Loader /></div> : expandEmailHistory?.expand && (parentEmail?.domain === "google" ? expandEmailHistory?.parentId === parentEmail?.threadId : expandEmailHistory?.parentId === parentEmail?.conversationId) && <>
                    <div className='d-flex justify-content-start align-items-center  column-gap-2' style={{ color: '#214466', letterSpacing: 1 }}>
                        <span className='fw-bold fs-5' style={{ color: 'black' }}>To: </span>
                        <div className='d-flex column-gap-2'>
                            <p className='m-0 fw-bold fs-5'>{parentEmail?.receiverEmail}</p>
                        </div>
                    </div>
                    {parentEmail?.Cc?.length !== 0 && <div className='d-flex justify-content-start align-items-center  column-gap-2' style={{ color: '#214466', letterSpacing: 1 }}>
                        <span className='fw-bold fs-5' style={{ color: 'black' }}>Cc: </span>
                        <div className='d-flex column-gap-2'>
                            <p className='m-0 fw-bold fs-5'>{parentEmail?.Cc?.join(", ")}</p>
                        </div>
                    </div>}
                    {parentEmail?.Bcc?.length !== 0 && <div className='d-flex justify-content-start align-items-center  column-gap-2' style={{ color: '#214466', letterSpacing: 1 }}>
                        <span className='fw-bold fs-5' style={{ color: 'black' }}>Bcc: </span>
                        <div className='d-flex column-gap-2'>
                            <p className='m-0 fw-bold fs-5'>{parentEmail?.Bcc?.join(", ")}</p>
                        </div>
                    </div>}
                    <div className='d-flex justify-content-start align-items-center column-gap-2' style={{ color: '#214466', letterSpacing: 1 }}>
                        <span className='fw-bold fs-5' style={{ color: 'black' }}>From: </span>
                        <div className='d-flex column-gap-2'>
                            <p className='m-0 fw-bold fs-5' >{parentEmail?.senderEmail}</p>
                        </div>
                    </div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: parentEmail?.mainBody ? parentEmail?.mainBody : parentEmail?.body,
                        }}
                        style={{ border: "1px solid #ccc", padding: "10px", fontSize: 16 }}
                        className='mt-3 rounded'
                    >
                    </div>
                </>}
                {(!parentEmail?.isRead || newChildEmailsExist) && <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fs-5">
                    new
                </span>}
            </div>
            {expandEmailHistory?.expand && (parentEmail?.domain === "google" ? expandEmailHistory?.parentId === parentEmail?.threadId : expandEmailHistory?.parentId === parentEmail?.conversationId) && childEmailsForParentEmail?.length > 0 && <div className='mt-3 w-100' style={{ height: 'auto', marginLeft: 100 }}>
                {childEmailsForParentEmail?.map((emailHistory) => {
                    return (
                        <ChildEmailHistory
                            emailHistory={emailHistory}
                            key={emailHistory?.messageId}
                            contacts={contacts}
                            onClose={handleReplyEmailClose}
                            setShow={setShow}
                            show={show}
                            oldEmails={oldEmails}
                            setOldEmails={setOldEmails}
                            setAllUnreadEmailCount={setAllUnreadEmailCount}
                            parentEmail={parentEmail}
                            setMainEmail={setMainEmail}
                            callerAssignedForEmail={callerAssignedForEmail}
                            updateParentEmailForNewTag={updateParentEmailForNewTag}
                            vendorId={vendorId}
                        />
                    )
                })}
            </div>}

            {show && (
                <>
                    <ModalComponent modalTitle='' open={show} handleClose={() => { setShow(false) }} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <ComposeEmail
                            onClose={handleReplyEmailClose}
                            contacts={contacts}
                            componentFor={''}
                            actionOnEmail={actionOnEmail}
                            setShow={setShow}
                            oldEmails={oldEmails}
                            childEmailsForParentEmail={childEmailsForParentEmail}
                            expandEmailHistory={expandEmailHistory}
                            activeTab={'notes'}
                            vendorId={vendorId}
                        />
                    </ModalComponent>
                </>
            )}
        </>
    )
}



export default EmailHistory;